var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"player",staticClass:"video-js vjs-city-offer vjs-show-big-play-button-on-pause minimalistic",style:(_vm.playerStyle),attrs:{"controls":"","playsinline":"","preload":"auto"}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.mime}})])
}
var staticRenderFns = []

export { render, staticRenderFns }